import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { B2BTNKLoanFormComponent } from './b2b-loan-form.component';
import { B2BTNKLoanFormService } from './b2b-loan-form.service';
import { TNKDateDropdownModule } from '../../components/date-dropdown/date-dropdown.module';
import { TNKUtilitiesModule } from '../../utils/utilities.module';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { TNKLoanSliderModule } from '../../components/loan-slider/loan-slider.module';
import { TNKCurrencyMaskDirective } from '../../utils/currency-mask/currency-mask.directive';
import { TNKAccessibleFormDirective } from '../../utils/accessible-form/accessible-form.directive';
import { PlatformService } from '../../services/platform.services';
import { CurrencyMaskModule } from 'ng2-currency-mask';
export class B2BTNKLoanFormModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TNKUtilitiesModule,
    TNKLoanSliderModule,
    RouterModule,
    TNKUtilitiesModule,
    TNKDateDropdownModule,
  ],
  declarations: [B2BTNKLoanFormComponent],
  exports: [B2BTNKLoanFormComponent],
  providers: [B2BTNKLoanFormService, ApiConstant, PlatformService],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function B2BTNKLoanFormModule_tsickle_Closure_declarations() {
/** @type {?} */
B2BTNKLoanFormModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
B2BTNKLoanFormModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
